module.exports = __webpack_public_path__ + "cd455783/img/archive-icon.0a6a9de3.svg";